import { ComponentProps } from 'react'

import { astraTwMerge } from '../../Utilities/astraTwMerge'

/** A display-only column that stays visible beside the selectable cells. */
export function SummaryCell({ className, ...props }: ComponentProps<'div'>) {
    return (
        <div
            {...props}
            data-grid-summary=""
            className={astraTwMerge('sticky right-0 z-elevated overflow-hidden border-l-[6px] border-subtle bg-surface-base', className)}
        />
    )
}
